// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"ShortCourseDetailsPage_loadingContainer_3eszs"};